import { render, staticRenderFns } from "./TypeTextImageButton.vue?vue&type=template&id=36bf9ea6&scoped=true"
import script from "./TypeTextImageButton.vue?vue&type=script&lang=js"
export * from "./TypeTextImageButton.vue?vue&type=script&lang=js"
import style0 from "./TypeTextImageButton.vue?vue&type=style&index=0&id=36bf9ea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bf9ea6",
  null
  
)

export default component.exports